import React, { Component } from 'react'
import {
  Popup,
  Form,
  Button,
  ScrollView,
  Tabs,
  FileUploader,
} from 'devextreme-react'
import { showLoading } from 'redux/actions/loading'
import {
  formatDate,
  formatNumber,
  formatUploadFileData,
  imageSource,
} from 'plugin/helper'
import httpRequest from 'plugin/httprequest'
import DevExpressDataGrid from 'components/inheritComponent/devexpressdatagrid'
import { alert, confirm } from 'devextreme/ui/dialog'
import { banks, productDefault } from 'dataSource/lookup'
import FormPenarikan from './penarikan'
import FormPensiunNormal from './pensiunNormal'
import FormPensiunDipercepat from './pensiunDipercepat'
import FormPenarikanSebagian from './penarikanSebagianIuran'
import FormPengalihan from './pengalihan'
import ModalPreviewPdf from 'components/pages/modal/previewPdf'

class ModalKlaimParticipant extends Component {
  constructor(props) {
    super(props)

    this.state = {
      FormFilter: {},
      FormDetail: {},
      FormCalculate: {},
      mplTotal: 0,
      selectedTabIndex: 0,
      DataDocument: [],
    }

    this.sysDate = props.store.getState().getParam
      ? props.store
          .getState()
          .getParam.find((value) => value.paramCode === '0 SYSDATE')
      : null
    this.date = new Date(this.sysDate ? this.sysDate.dateValue : null)

    this.PopupRef = React.createRef()
    this.FormFilterRef = React.createRef()
    this.DataGridRef = React.createRef()
    this.DatagridCalculateRef = React.createRef()
    this.FormDetailRef = React.createRef()
    this.FormCalculateRef = React.createRef()
    this.FormPenarikanRef = React.createRef()
    this.FormPensiunNormalRef = React.createRef()
    this.FormPensiunDipercepatRef = React.createRef()
    this.FormPenarikanSebagianRef = React.createRef()
    this.FormPengalihanRef = React.createRef()
    this.modalPreviewRef = React.createRef()

    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)

    this.dataResult = []
    this.dataCalculate = []

    this.PopupToolbarItem = [
      {
        widget: 'dxButton',
        location: 'after',
        options: {
          text: 'Simpan',
          elementAttr: { class: 'bg-button-popup-save-dapen-default' },
          onClick: async () => {
            let result = await confirm(
              'Apakah anda yakin menyimpan data ini?',
              'Konfirmasi'
            )
            if (result) {
              await this.submitData()
            }
          },
        },
        toolbar: 'bottom',
      },
      {
        widget: 'dxButton',
        location: 'after',
        options: {
          text: 'Tutup',
          elementAttr: { class: 'bg-button-popup-close-dapen-default' },
          onClick: this.hide.bind(this),
        },
        toolbar: 'bottom',
      },
    ]

    this.TabDataSource = [
      {
        id: 0,
        text: 'Penarikan < 3 Tahun',
      },
      {
        id: 1,
        text: 'Pensiun Normal',
      },
      {
        id: 2,
        text: 'Pensiun Dipercepat',
      },
      {
        id: 3,
        text: 'Penarikan Sebagian Iuran',
      },
      {
        id: 4,
        text: 'Pengalihan DPLK Lain',
      },
    ]

    this.FormFilter = [
      {
        dataField: 'cardNo',
        label: {
          text: 'Nomor Kartu',
        },
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-dapen-default' },
          placeholder: 'Nomor Kartu',
        },
      },
      {
        dataField: 'fullName',
        label: {
          text: 'Nama Lengkap',
        },
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-dapen-default' },
          placeholder: 'Nama Lengkap',
        },
      },
      {
        dataField: 'nik',
        label: {
          text: 'NIK',
        },
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-dapen-default' },
          placeholder: 'NIK',
        },
      },
      {
        dataField: 'ktp',
        label: {
          text: 'Nomor KTP',
        },
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-dapen-default' },
          placeholder: 'Nomor KTP',
        },
      },
      {
        dataField: 'noHp',
        label: {
          text: 'Nomor HP',
        },
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-dapen-default' },
          placeholder: 'Nomor HP',
        },
      },
      {
        dataField: 'tanggalLahir',
        label: {
          text: 'Tanggal Lahir',
        },
        editorType: 'dxDateBox',
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-dapen-default' },
          displayFormat: 'dd MMM yyyy',
          useMaskBehavior: true,
          width: '100%',
          openOnFieldClick: true,
          placeholder: 'Tanggal Lahir',
        },
      },
    ]

    this.columns = [
      {
        dataField: 'no',
        caption: 'No.',
        cellRender: (e) => {
          return e.rowIndex + 1
        },
        width: '40px',
      },
      {
        dataField: 'namaLengkap',
        caption: 'Nama Lengkap',
      },
      {
        dataField: 'nik',
        caption: 'NIK',
      },
      {
        dataField: 'nomorKtp',
        caption: 'Nomor KTP',
      },
      {
        dataField: 'nomorHp',
        caption: 'Nomor HP',
      },
      {
        dataField: 'tanggalLahir',
        caption: 'Tanggal Lahir',
        dataType: 'date',
        format: 'dd MMM yyyy',
      },
      {
        dataField: 'product',
        caption: 'Produk',
      },
      {
        dataField: 'action',
        caption: 'Aksi',
        cellRender: (e) => {
          return (
            <button
              className="btn btn-sm btn-outline-dark"
              onClick={async () => this.getData(e.row.data)}
            >
              <i className="fa fa-eye"></i>
            </button>
          )
        },
        width: 'auto',
      },
    ]

    this.FormDetail = [
      {
        itemType: 'group',
        cssClass: 'group-form',
        items: [
          {
            dataField: 'fullName',
            label: {
              text: 'Nama Lengkap',
            },
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
              readOnly: true,
            },
          },
          {
            dataField: 'nik',
            label: {
              text: 'NIK',
            },
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
              readOnly: true,
            },
          },
          {
            dataField: 'noKtp',
            label: {
              text: 'Nomor KTP',
            },
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
              readOnly: true,
            },
          },
          {
            dataField: 'birthDate',
            label: {
              text: 'Tanggal Lahir',
            },
            editorType: 'dxDateBox',
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
              readOnly: true,
              displayFormat: 'dd MMM yyyy',
              useMaskBehavior: true,
              width: '100%',
            },
          },
          {
            dataField: 'efektifDate',
            label: {
              text: 'Tgl Efektif Kepesertaan',
            },
            editorType: 'dxDateBox',
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
              readOnly: true,
              displayFormat: 'dd MMM yyyy',
              useMaskBehavior: true,
              width: '100%',
            },
          },
          {
            dataField: 'productId',
            label: {
              text: 'Produk',
            },
            editorType: 'dxSelectBox',
            editorOptions: {
              elementAttr: {
                class: 'bd-input-popup-disabled-dapen-default',
                style: 'margin-bottom: 0.8rem !important',
              },
              dataSource: productDefault(this.props.store),
              valueExpr: 'id',
              displayExpr: 'productName',
              readOnly: true,
            },
          },
        ],
      },
      {
        itemType: 'group',
        cssClass: 'group-form ml-3',
        items: [
          {
            dataField: 'rekeningNo',
            label: {
              text: 'Nomor Rekening',
            },
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
              readOnly: true,
            },
          },
          {
            dataField: 'rekeningNama',
            label: {
              text: 'Nama Rekening',
            },
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
              readOnly: true,
            },
          },
          {
            dataField: 'rekeningBankId',
            label: {
              text: 'Bank',
            },
            editorType: 'dxSelectBox',
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
              dataSource: banks(this.props.store),
              valueExpr: 'id',
              displayExpr: 'bankName',
              readOnly: true,
            },
          },
          {
            dataField: 'rekeningBranchBank',
            label: {
              text: 'Cabang Bank',
            },
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
              readOnly: true,
            },
          },
          {
            dataField: 'klaimDate',
            label: {
              text: 'Tgl Klaim',
            },
            editorType: 'dxDateBox',
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
              readOnly: true,
              displayFormat: 'dd MMM yyyy',
              useMaskBehavior: true,
              width: '100%',
            },
          },
          {
            dataField: 'klaimTypeId',
            label: {
              text: 'Jenis Klaim',
            },
            editorType: 'dxSelectBox',
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-dapen-default' },
              dataSource: [
                { id: 1, name: 'Penarikan < 3 Tahun' },
                { id: 2, name: 'Pensiun Normal' },
                { id: 3, name: 'Pensiun Dipercepat' },
                { id: 4, name: 'Penarikan Sebagian Iuran' },
                { id: 5, name: 'Pengalihan DPLK Lain' },
              ],
              valueExpr: 'id',
              displayExpr: 'name',
              searchEnabled: true,
              deferRendering: false,
            },
          },
        ],
      },
    ]

    this.FormCalculate = [
      {
        dataField: 'lastIuranDate',
        label: {
          text: 'Tgl Iuran Terakhir',
        },
        editorType: 'dxDateBox',
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
          readOnly: true,
          displayFormat: 'dd MMM yyyy',
          useMaskBehavior: true,
          width: '100%',
        },
      },
      {
        dataField: 'lastKlaimAmount',
        label: {
          text: 'Jumlah Klaim Terakhir',
        },
        editorType: 'dxNumberBox',
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
          readOnly: true,
          format: '#,##0.00',
        },
      },
      {
        dataField: 'jumlahSaldo',
        label: {
          text: 'Jumlah Saldo',
        },
        editorType: 'dxNumberBox',
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
          readOnly: true,
          format: '#,##0.00',
        },
      },

      {
        dataField: 'totalSaldoMpl',
        label: {
          text: 'Jumlah Saldo + Manfaat Lain',
        },
        editorType: 'dxNumberBox',
        editorOptions: {
          elementAttr: {
            class: 'bd-input-popup-disabled-dapen-default',
            style: 'margin-bottom: 3.5rem !important',
          },
          readOnly: true,
          format: '#,##0.00',
        },
      },
    ]

    this.columnCalculates = [
      {
        dataField: 'mplId',
        caption: 'ID',
      },
      {
        dataField: 'mplName',
        caption: 'Nama Manfaat Pensiun Lain',
      },
      {
        dataField: 'mplPersen',
        caption: 'Saldo (%)',
        dataType: 'number',
        alignment: 'right',
        format: '#0',
      },
      {
        dataField: 'mplNominal',
        caption: 'Nominal',
        dataType: 'number',
        alignment: 'right',
        format: '#,##0.00',
      },
    ]
  }

  show = () => {
    this.setState({
      popupVisible: true,
    })
  }

  hide = () => {
    const formRefs = [
      this.FormPenarikanRef,
      this.FormPensiunNormalRef,
      this.FormPensiunDipercepatRef,
      this.FormPenarikanSebagianRef,
      this.FormPengalihanRef,
    ]

    formRefs.forEach((ref) => {
      if (ref.current) {
        ref.current.clearData()
      }
    })

    this.dataResult = []
    this.dataCalculate = []

    if (this.DataGridRef.current) {
      this.forceRefresh()
    }
    if (this.DataGridCalculateRef) {
      this.forceRefreshCalculate()
    }

    this.setState({
      popupVisible: false,
      FormFilter: {},
      FormDetail: {},
      FormCalculate: {},
      mplTotal: 0,
      DataDocument: [],
      FormData: {},
    })
  }

  onTabSelectionChanged = (args) => {
    if (args.name === 'selectedIndex' && args.value !== -1) {
      this.setState({
        selectedTabIndex: args.value,
      })
    }
  }

  clearData = () => {
    this.dataResult = []
    this.forceRefresh()

    this.setState({
      FormData: {},
    })
  }

  advanceSearch = async () => {
    let { cardNo, fullName, nik, ktp, noHp, tanggalLahir, alamat, noRek } =
      this.state.FormFilter
    if (
      !cardNo &&
      !fullName &&
      !nik &&
      !ktp &&
      !noHp &&
      !tanggalLahir &&
      !alamat &&
      !noRek
    ) {
      alert('Harus terdapat minimal 1 kolom yang diisi', 'Tidak Sesuai')
      return null
    }

    this.props.store.dispatch(showLoading(true))
    try {
      let getDatagrid = await httpRequest(
        process.env.REACT_APP_BACKEND_CORE,
        this.props.store,
        `db-client-search`,
        'POST',
        {
          values: {
            cardNo: cardNo,
            fullName: fullName,
            nik: nik,
            ktp: ktp,
            noHp: noHp,
            tanggalLahir: tanggalLahir ? formatDate(tanggalLahir) : null,
            alamat: alamat,
            noRek: noRek,
            participantId: this.props.store.getState().sessionUser
              ? this.props.store.getState().sessionUser.participantId
              : 0,
          },
        }
      )

      if (getDatagrid.length > 0) {
        this.dataResult = getDatagrid
        this.forceRefresh()
        this.props.store.dispatch(showLoading(false))
      } else {
        this.dataResult = []
        this.forceRefresh()
        this.props.store.dispatch(showLoading(false))
      }
    } catch (e) {
      console.error(e)
      this.props.store.dispatch(showLoading(false))
    }
  }

  loadData = () => {
    return this.dataResult
  }

  getData = async (data) => {
    if (data) {
      this.props.store.dispatch(showLoading(true))
      try {
        let getKP = await httpRequest(
          process.env.REACT_APP_BACKEND_CORE,
          this.props.store,
          `simple-kepersertaan-products/getById/${data.kpId}`,
          'GET'
        )
        if (getKP) {
          let getPeserta = await httpRequest(
            process.env.REACT_APP_BACKEND_CORE,
            this.props.store,
            `simple-pesertas/getSimpleById/${getKP.pesertaId}`,
            'GET'
          )

          let formDetail = {
            efektifDate: getKP.efektifDate,
            productId: getKP.productId,
            kpId: data.kpId,
            pesertaId: getKP.pesertaId,
            regPesertaId: getPeserta.regPesertaId,
            fullName: getPeserta.fullName,
            nik: getPeserta.nik,
            noKtp: getPeserta.noKtp,
            birthDate: getPeserta.birthDate,
            rekeningNo: getPeserta.rekeningNo,
            rekeningNama: getPeserta.rekeningNama,
            rekeningBankId: getPeserta.rekeningBankId,
            klaimDate: this.date,
            klaimTypeId: data.klaimTypeId || null,
            id: data.id || null,
          }

          this.FormDetailRef.current.instance.updateData(formDetail)
          this.props.store.dispatch(showLoading(false))
        }
      } catch (e) {
        console.error(e)
        this.props.store.dispatch(showLoading(false))
      }
    }
  }

  calculate = async () => {
    const { FormDetail } = this.state
    const { store } = this.props

    if (!FormDetail || !FormDetail.klaimTypeId) {
      alert('Jenis Klaim Harus Diisi!', 'Tidak Sesuai')
      return
    }

    store.dispatch(showLoading(true))

    try {
      const endpoint = `ppip-klaims/calculate/${FormDetail.kpId}/${formatDate(
        FormDetail.klaimDate
      )}/${FormDetail.productId}/${FormDetail.klaimTypeId}`
      const getCalculate = await httpRequest(
        process.env.REACT_APP_BACKEND_CORE,
        store,
        endpoint,
        'GET'
      )

      if (getCalculate.length === 0) {
        store.dispatch(showLoading(false))
        return
      }

      const calculationData = getCalculate[0]
      const dataFormCalculate = {
        lastIuranDate: calculationData.lastIuranDate,
        lastKlaimAmount: calculationData.lastKlaimAmount,
        jumlahSaldo: calculationData.jumlahSaldo,
      }

      this.dataCalculate = getCalculate
      this.forceRefreshCalculate()
      this.FormCalculateRef.current.instance.updateData(dataFormCalculate)

      this.setState({
        mplTotal: calculationData.mplTotal || 0,
      })

      const formRefs = {
        1: this.FormPenarikanRef,
        2: this.FormPensiunNormalRef,
        3: this.FormPensiunDipercepatRef,
        4: this.FormPenarikanSebagianRef,
        5: this.FormPengalihanRef,
      }

      Object.keys(formRefs).forEach((key) => {
        const ref = formRefs[key]
        if (ref && ref.current) {
          if (parseInt(key, 10) === FormDetail.klaimTypeId) {
            ref.current.loadData(calculationData)
          } else {
            ref.current.clearData()
          }
        }
      })
    } catch (e) {
      console.error(e)
      store.dispatch(showLoading(false))
      alert('Terjadi kesalahan sistem', 'Terjadi Kesalahan')
    } finally {
      store.dispatch(showLoading(false))
    }
  }

  loadDataCalculate = () => {
    return this.dataCalculate
  }

  onUploadDocument = (e, dokumenTypeId) => {
    const processFile = (file) => {
      let fr = new FileReader()
      fr.onload = (efr) => {
        let formattedFileData = formatUploadFileData(efr.target.result)
        this.setState(
          (prevState) => {
            const existingIndex = prevState.DataDocument.findIndex(
              (doc) => doc.dokumenTypeId === dokumenTypeId
            )
            const newDocument = {
              fileName: file.name,
              fileDocument: formattedFileData.base64data,
              fileDocumentContentType: formattedFileData.mime,
              dokumenTypeId: dokumenTypeId,
            }
            const updatedDataDocument =
              existingIndex !== -1
                ? [
                    ...prevState.DataDocument.slice(0, existingIndex),
                    newDocument,
                    ...prevState.DataDocument.slice(existingIndex + 1),
                  ]
                : [...prevState.DataDocument, newDocument]
            return { DataDocument: updatedDataDocument }
          },
          () => {
            console.log('Updated DataDocument:', this.state.DataDocument)
          }
        )
      }
      fr.readAsDataURL(file)
    }

    for (let i = 0; i < e.value.length; i++) {
      processFile(e.value[i])
    }
  }

  previewFile = (dokumenTypeId) => {
    const { DataDocument } = this.state
    const docData = DataDocument.find(
      (doc) => doc.dokumenTypeId === dokumenTypeId
    )

    if (docData && docData.fileDocument) {
      const src = imageSource(
        docData.fileDocumentContentType,
        docData.fileDocument
      )

      this.modalPreviewRef.current.show()
      this.modalPreviewRef.current.retrieveData(src)
    } else {
      console.log('Dokumen tidak ditemukan atau fileName tidak ada.')
    }
  }

  submitData = async () => {
    const { FormDetail } = this.state
    const { store } = this.props
    let tabParameter
    const formRefs = {
      1: this.FormPenarikanRef,
      2: this.FormPensiunNormalRef,
      3: this.FormPensiunDipercepatRef,
      4: this.FormPenarikanSebagianRef,
      5: this.FormPengalihanRef,
    }
    const formRef = formRefs[FormDetail.klaimTypeId]
    if (formRef && formRef.current) {
      tabParameter = formRef.current.sendData()
      const resultData = {
        anuitasAsuransiId: tabParameter.anuitasAsuransiId || null,
        anuitasProductId: tabParameter.anuitasProductId || null,
        berkalaPeriodePembayaran: tabParameter.berkalaPeriodePembayaran || null,
        berkalaTahunPembayaran: tabParameter.berkalaTahunPembayaran || null,
        berkalaTanggalPembayaran: tabParameter.berkalaTanggalPembayaran
          ? formatDate(tabParameter.berkalaTanggalPembayaran)
          : null,
        dplkLainPerusahaan: tabParameter.dplkLainPerusahaan || null,
        dplkLainProduct: tabParameter.dplkLainProduct || null,
        dplkLainRekBankId: tabParameter.dplkLainRekBankId || null,
        dplkLainRekCabang: tabParameter.dplkLainRekCabang || null,
        dplkLainRekNama: tabParameter.dplkLainRekNama || null,
        dplkLainRekNo: tabParameter.dplkLainRekNo || null,
        jumlahSaldo: tabParameter.jumlahSaldo,
        jumlahSaldoMpl: tabParameter.jumlahSaldoMpl,
        klaimAmount: tabParameter.klaimAmount || 0,
        klaimAmountNett: tabParameter.klaimAmountNett,
        klaimBiayaKomisi: tabParameter.klaimBiayaKomisi,
        klaimMaxNominal: tabParameter.klaimMaxNominal,
        klaimMaxPersen: tabParameter.klaimMaxPersen,
        klaimOnlineMpLainDTOList: [
          {
            mpTypeId: tabParameter.mpTypeId,
            nominalMp: tabParameter.mplNominal,
            persenSaldo: tabParameter.mplPersen,
          },
        ],
        klaimPersen: tabParameter.klaimPersen || 100,
        klaimStatusId: 28,
        klaimTax: tabParameter.klaimTax,
        klaimTransaferValue: tabParameter.klaimTransaferValue || 0,
        klaimTypeId: FormDetail.klaimTypeId,
        klaimValueTipe: 'Gross',
        kpId: FormDetail.kpId,
        lastIuranDate: FormDetail.lastIuranDate
          ? formatDate(FormDetail.lastIuranDate)
          : null,
        lastKlaimAmount: tabParameter.lastKlaimAmount || 0,
        mpSekaligus: tabParameter.mpSekaligus
          ? tabParameter.mpSekaligus.value === 1
          : false,
        pembelianAnuitas: tabParameter.pembelianAnuitas || false,
        pembelianAnuitasValue: tabParameter.pembelianAnuitasValue || null,
        pembelianBerkala: tabParameter.pembelianBerkala || false,
        pembelianBerkalaValue: tabParameter.pembelianBerkalaValue || null,
        regPesertaId: FormDetail.regPesertaId,
        rekBankId: FormDetail.rekeningBankId,
        rekName: FormDetail.rekeningNama,
        rekNo: FormDetail.rekeningNo,
        tanggalKlaim: FormDetail.klaimDate
          ? formatDate(FormDetail.klaimDate)
          : null,
        tanggalLahir: FormDetail.birthDate
          ? formatDate(new Date(FormDetail.birthDate))
          : null,
        id: FormDetail.id || null,
      }

      store.dispatch(showLoading(true))
      try {
        let postKlaim
        if (resultData.id) {
          postKlaim = await httpRequest(
            process.env.REACT_APP_BACKEND_CORE,
            this.props.store,
            'ppip-klaims/request-klaim',
            'POST',
            { values: resultData }
          )
        } else {
          delete resultData.id
          postKlaim = await httpRequest(
            process.env.REACT_APP_BACKEND_CORE,
            this.props.store,
            'ppip-klaims/request-klaim',
            'POST',
            { values: resultData }
          )
        }

        if (postKlaim) {
          const documentSaved = await this.saveDocument(postKlaim.id)
          store.dispatch(showLoading(false))

          if (documentSaved) {
            let close = await alert(
              'Simpan Data Berhasil Dilakukan!',
              'Berhasil'
            )
            if (close) {
              this.hide()
              this.props.forceRefresh()
            }
          } else {
            alert('Gagal menyimpan dokumen', 'Gagal')
          }
        }
      } catch (e) {
        console.error(e)
        store.dispatch(showLoading(false))
      }
    }
  }

  saveDocument = async (klaimId) => {
    if (klaimId) {
      const { DataDocument } = this.state
      if (DataDocument.length > 0) {
        try {
          const insertProcess = async (param, klaimId, dokumenTypeId) => {
            const loadAPIDoc = `dokumen-klaim-ppips/klaim?dokumenTypeId=${dokumenTypeId}&klaimId=${klaimId}`
            const responseDoc = await httpRequest(
              process.env.REACT_APP_BACKEND_CORE,
              this.props.store,
              loadAPIDoc,
              'GET'
            )

            if (responseDoc.length === 0) {
              const insertAPIDoc = 'dokumen-klaim-ppips'
              await httpRequest(
                process.env.REACT_APP_BACKEND_CORE,
                this.props.store,
                insertAPIDoc,
                'POST',
                { values: param }
              )
            } else {
              const dataDocExist = responseDoc[0]
              const updateAPIDoc = 'dokumen-klaim-ppips'
              await httpRequest(
                process.env.REACT_APP_BACKEND_CORE,
                this.props.store,
                updateAPIDoc,
                'PUT',
                { values: param, key: dataDocExist.id },
                dataDocExist
              )
            }
          }

          const allowedDokumenTypeIds = [1, 7, 14, 4, 5]

          for (const value of DataDocument) {
            if (allowedDokumenTypeIds.includes(value.dokumenTypeId)) {
              const params = {
                dokumenTypeId: value.dokumenTypeId,
                fileDocument: value.fileDocument,
                fileDocumentContentType: value.fileDocumentContentType,
                fileName: value.fileName,
                klaimId: klaimId,
                uploadDate: formatDate(new Date()),
              }

              await insertProcess(params, klaimId, value.dokumenTypeId)
            }
          }
          return true
        } catch (error) {
          console.error('Error in saveDocument:', error)
          return false
        }
      }
    }
  }

  retrieveData = async (data) => {
    if (data) {
      let getKlaimData = await httpRequest(
        process.env.REACT_APP_BACKEND_CORE,
        this.props.store,
        `ppip-klaims/${data.id}`,
        'GET'
      )
      if (getKlaimData) {
        let getDocument = await httpRequest(
          process.env.REACT_APP_BACKEND_CORE,
          this.props.store,
          `dokumen-klaim-ppips/klaim?klaimId=${data.id}`,
          'GET'
        )

        if (getDocument.length > 0) {
          this.setState({
            DataDocument: getDocument,
          })
        }

        await this.getData(getKlaimData)
        await this.calculate()
      }
    }
  }

  forceRefresh = () => {
    this.DataGridRef.current.forceRefresh(true)
  }

  forceRefreshCalculate = () => {
    this.DatagridCalculateRef.current.forceRefresh(true)
  }

  renderElement = () => {
    return (
      <>
        <section>
          <Form
            colCount={3}
            id={'advanceSearchForm'}
            ref={this.FormFilterRef}
            labelLocation={'left'}
            formData={this.state.FormFilter}
            items={this.FormFilter}
          />
        </section>
        <section className="d-flex flex-row justify-content-end">
          <Button
            elementAttr={{
              class: 'bg-button-popup-save-dapen-default mr-2',
            }}
            text={'Proses'}
            type={'success'}
            stylingMode={'contained'}
            onClick={async (e) => {
              await this.advanceSearch()
            }}
            visible={true}
          />
          <Button
            elementAttr={{
              class: 'bg-button-popup-close-dapen-default',
            }}
            text={'Hapus'}
            type={'success'}
            stylingMode={'contained'}
            onClick={() => {
              this.clearData()
            }}
            visible={true}
          />
        </section>
        <section className="mt-3">
          <DevExpressDataGrid
            keyField="kpId"
            ref={this.DataGridRef}
            loadAPI={`-`}
            insertAPI="-"
            updateAPI="-"
            deleteAPI="-"
            backendserver={process.env.REACT_APP_BACKEND_CORE}
            useArraySource={true}
            ArraySourceData={this.loadData}
            allowAdding={false}
            allowDeleting={false}
            allowUpdating={false}
            height={'35vh'}
            showBorders={true}
            paging={false}
            defaultPageSize={5}
            ColumnChooser={false}
            ColumnFixing={false}
            FilterRow={false}
            ColumnConfiguration={this.columns}
            store={this.props.store}
          />
        </section>
        <section className="mt-3">
          <Form
            colCount={2}
            id={'formDetail'}
            ref={this.FormDetailRef}
            labelLocation={'left'}
            formData={this.state.FormDetail}
            items={this.FormDetail}
          />
        </section>
        <section className="d-flex flex-row justify-content-center">
          <Button
            elementAttr={{
              class: 'bg-button-popup-save-dapen-default',
            }}
            text={'Hitung'}
            type={'success'}
            stylingMode={'contained'}
            width={'40vw'}
            onClick={async (e) => {
              await this.calculate()
            }}
            visible={true}
          />
        </section>
        <section className="mt-3">
          <div className="row">
            <div className="col-6">
              <div className="group-form" style={{ width: '100%' }}>
                <h2 className="sub-title">Saldo Terakhir</h2>
                <Form
                  colCount={1}
                  id={'formCalculate'}
                  ref={this.FormCalculateRef}
                  labelLocation={'left'}
                  formData={this.state.FormCalculate}
                  items={this.FormCalculate}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="group-form" style={{ width: '100%' }}>
                <h2 className="sub-title">Manfaat Pensiun Lain</h2>
                <DevExpressDataGrid
                  keyField="mplId"
                  ref={this.DatagridCalculateRef}
                  loadAPI={`-`}
                  insertAPI="-"
                  updateAPI="-"
                  deleteAPI="-"
                  backendserver={process.env.REACT_APP_BACKEND_CORE}
                  useArraySource={true}
                  ArraySourceData={this.loadDataCalculate}
                  allowAdding={false}
                  allowDeleting={false}
                  allowUpdating={false}
                  height={'20vh'}
                  showBorders={true}
                  paging={false}
                  defaultPageSize={5}
                  ColumnChooser={false}
                  ColumnFixing={false}
                  FilterRow={false}
                  ColumnConfiguration={this.columnCalculates}
                  store={this.props.store}
                />
                <div className="d-flex flex-row justify-content-end mt-3">
                  <div>
                    <span className="dx-form-group-caption">
                      Total Manfaat Pensiun Lain{' '}
                    </span>
                    <span>
                      <strong>Rp. {formatNumber(this.state.mplTotal)}</strong>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="mt-3">
          <div className="row">
            <div className="col-12">
              <Tabs
                dataSource={this.TabDataSource}
                selectedIndex={this.state.selectedTabIndex}
                onOptionChanged={this.onTabSelectionChanged}
              />
            </div>
          </div>
          <div>
            <div
              id={`tabIndexModalDetil-0`}
              className={
                (this.state.selectedTabIndex !== 0 ? 'd-none' : '') +
                ' mt-3 container-fluid'
              }
            >
              <FormPenarikan
                store={this.props.store}
                ref={this.FormPenarikanRef}
              />
            </div>
            <div
              id={`tabIndexModalDetil-1`}
              className={
                (this.state.selectedTabIndex !== 1 ? 'd-none' : '') +
                ' mt-3 container-fluid'
              }
            >
              <FormPensiunNormal
                store={this.props.store}
                ref={this.FormPensiunNormalRef}
              />
            </div>
            <div
              id={`tabIndexModalDetil-2`}
              className={
                (this.state.selectedTabIndex !== 2 ? 'd-none' : '') +
                ' mt-3 container-fluid'
              }
            >
              <FormPensiunDipercepat
                store={this.props.store}
                ref={this.FormPensiunDipercepatRef}
              />
            </div>
            <div
              id={`tabIndexModalDetil-3`}
              className={
                (this.state.selectedTabIndex !== 3 ? 'd-none' : '') +
                ' mt-3 container-fluid'
              }
            >
              <FormPenarikanSebagian
                store={this.props.store}
                ref={this.FormPenarikanSebagianRef}
              />
            </div>
            <div
              id={`tabIndexModalDetil-4`}
              className={
                (this.state.selectedTabIndex !== 4 ? 'd-none' : '') +
                ' mt-3 container-fluid'
              }
            >
              <FormPengalihan
                store={this.props.store}
                ref={this.FormPengalihanRef}
              />
            </div>
          </div>
        </section>
        <section className="mt-3">
          <div className="group-form">
            <span className="dx-form-group-caption">Dokumen Umum</span>
            <div style={{ width: '50vw' }}>
              <div className="row">
                <div className="col-6">
                  <FileUploader
                    uploadMode={'useForm'}
                    accept={'.png,.jpg,.jpeg,application/pdf'}
                    name={'documentKtp'}
                    onValueChanged={(e) => this.onUploadDocument(e, 1)}
                    labelText="Upload FC KTP"
                    showFileList={false}
                  />
                </div>
                <div className="col-6 d-flex flex-row align-items-center">
                  <button
                    onClick={() => this.previewFile(1)}
                    className={`btn btn-light btn-sm bg-button-popup-save-dapen-default ${
                      this.state.DataDocument.find(
                        (doc) => doc.dokumenTypeId === 1 && doc.fileDocument
                      )
                        ? ''
                        : 'd-none'
                    }`}
                    style={{ width: '122px' }}
                  >
                    Preview
                  </button>
                </div>
              </div>

              <div className="row">
                <div className="col-6">
                  <FileUploader
                    uploadMode={'useForm'}
                    accept={'.png,.jpg,.jpeg,application/pdf'}
                    name={'documentKk'}
                    onValueChanged={(e) => this.onUploadDocument(e, 7)}
                    labelText="Upload FC Kartu Keluarga"
                    showFileList={false}
                  />
                </div>
                <div className="col-6 d-flex flex-row align-items-center">
                  <button
                    onClick={() => this.previewFile(7)}
                    className={`btn btn-light btn-sm bg-button-popup-save-dapen-default ${
                      this.state.DataDocument.find(
                        (doc) => doc.dokumenTypeId === 7 && doc.fileDocument
                      )
                        ? ''
                        : 'd-none'
                    }`}
                    style={{ width: '122px' }}
                  >
                    Preview
                  </button>
                </div>
              </div>

              <div className="row">
                <div className="col-6">
                  <FileUploader
                    uploadMode={'useForm'}
                    accept={'.png,.jpg,.jpeg,application/pdf'}
                    name={'documentPeserta'}
                    onValueChanged={(e) => this.onUploadDocument(e, 14)}
                    labelText="Upload FC Kartu Peserta"
                    showFileList={false}
                  />
                </div>
                <div className="col-6 d-flex flex-row align-items-center">
                  <button
                    onClick={() => this.previewFile(14)}
                    className={`btn btn-light btn-sm bg-button-popup-save-dapen-default ${
                      this.state.DataDocument.find(
                        (doc) => doc.dokumenTypeId === 14 && doc.fileDocument
                      )
                        ? ''
                        : 'd-none'
                    }`}
                    style={{ width: '122px' }}
                  >
                    Preview
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="group-form">
            <span className="dx-form-group-caption">Dokumen PHK</span>
            <br />
            <span className="font-italic">
              Mohon dilampirkan untuk jenis klaim : Penarikan {'<'} 3 Tahun,
              Pensiun Normal, Pensiun Dipercepat, Pengalihan DPLK Lain
            </span>

            <div style={{ width: '50vw' }}>
              <div className="row">
                <div className="col-6">
                  <FileUploader
                    uploadMode={'useForm'}
                    accept={'.png,.jpg,.jpeg,application/pdf'}
                    name={'documentSkPHK'}
                    onValueChanged={(e) => this.onUploadDocument(e, 4)}
                    labelText="Upload FC SK PHK"
                    showFileList={false}
                  />
                </div>
                <div className="col-6 d-flex flex-row align-items-center">
                  <button
                    onClick={() => this.previewFile(4)}
                    className={`btn btn-light btn-sm bg-button-popup-save-dapen-default ${
                      this.state.DataDocument.find(
                        (doc) => doc.dokumenTypeId === 4 && doc.fileDocument
                      )
                        ? ''
                        : 'd-none'
                    }`}
                    style={{ width: '122px' }}
                  >
                    Preview
                  </button>
                </div>
              </div>

              <div className="row">
                <div className="col-6">
                  <FileUploader
                    uploadMode={'useForm'}
                    accept={'.png,.jpg,.jpeg,application/pdf'}
                    name={'documentSkPensiun'}
                    onValueChanged={(e) => this.onUploadDocument(e, 5)}
                    labelText="Upload FC SK Pensiun"
                    showFileList={false}
                  />
                </div>
                <div className="col-6 d-flex flex-row align-items-center">
                  <button
                    onClick={() => this.previewFile(5)}
                    className={`btn btn-light btn-sm bg-button-popup-save-dapen-default ${
                      this.state.DataDocument.find(
                        (doc) => doc.dokumenTypeId === 5 && doc.fileDocument
                      )
                        ? ''
                        : 'd-none'
                    }`}
                    style={{ width: '122px' }}
                  >
                    Preview
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    )
  }

  render() {
    let elem = this.state.popupVisible && this.renderElement()
    return (
      <Popup
        className={'popup'}
        visible={this.state.popupVisible}
        onHiding={this.hide}
        dragEnabled={false}
        showTitle={true}
        title="Form Klaim Participant"
        width={'80vw'}
        height={'90vh'}
        toolbarItems={this.PopupToolbarItem}
        ref={this.PopupRef}
      >
        <ScrollView width="100%" height="100%">
          <div className="container-fluid">{elem}</div>
        </ScrollView>

        <ModalPreviewPdf ref={this.modalPreviewRef} store={this.props.store} />
      </Popup>
    )
  }
}

export default ModalKlaimParticipant
